import { Link } from "@tanstack/react-router";
import { ChevronLeft } from "lucide-react";
import { cn } from "@/lib/utils";

interface BackLinkProps {
  to: string;
  label?: string;
  className?: string;
}

/**
 * Brand back-link used on focused flows (apply, auth, agreement)
 * that don't render the main Navbar. Keeps users one click from
 * the parent context.
 */
export function BackLink({ to, label = "Back", className }: BackLinkProps) {
  return (
    <Link
      to={to as any}
      className={cn(
        "inline-flex items-center gap-1.5 font-sans text-[12px] font-semibold uppercase tracking-[0.18em] text-bronze-600 hover:text-navy-800 transition-colors",
        className,
      )}
    >
      <ChevronLeft size={14} strokeWidth={2.5} aria-hidden />
      <span>{label}</span>
    </Link>
  );
}

export default BackLink;